import { gql } from "@apollo/client";

export const CONSENT_QUESTIONS = gql`
  query ConsentQuestionsForStore(
    $storeId: ID!
    $serviceTypes: [ServiceTypeOffering!]
  ) {
    store: node(id: $storeId) {
      ... on Store {
        id
        consentQuestionCategories {
          id
          name
          description
          questions(serviceTypes: $serviceTypes) {
            id
            question
            questionEs
            questionFr
            isRequired
            type
            flagVisitWhenEqual
            serviceTypes
          }
        }

        consentQuestions {
          id
          question
        }
      }
    }
  }
`;
